var React = require('react');
var PropTypes = React.PropTypes;
import QuestionContent from '../../QuestionContent/QuestionContent';
import CollectionCommentList from './CollectionCommentList';
import ReviewQuestion from './ReviewQuestion';
var ConceptRes = require('../../../resources/concept');
var ReviewTaskRes = require('../../../resources/review_task');
var Auth = require('../../../resources/auth');
import '../../../css/components/Tasks/Review/review_collection.css';
import '../../../css/components/Tasks/Review/comment.css';
import RaisedButton from 'material-ui/RaisedButton';
import { browserHistory } from 'react-router';
import notification from '../../Modal/notification';
import Helpers from '../../../utils/helpers';
import CollectionInfoRow from '../CollectionInfoRow';
import TransitionGroup from 'react-addons-transition-group';

var ReviewCollection = React.createClass({

  submitFinishReview: function() {
    var isValid = false;
    var reviewData = this.state.reviewTaskData;
    var taskRound = reviewData.reviewRound;
    var currentUser = Auth.getCurrentUser();
    var questionComplete = 0;
    for (var i in reviewData.contentInfo.questions) {
      var kquestion = reviewData.contentInfo.questions[i].kquestion;
      for (var j = 0; j < kquestion.reviewTasks.length; j++) {
        var task = kquestion.reviewTasks[j];
        if (task.reviewRound === taskRound && task.reviewer === currentUser._id && (task.reviewScore === 1 || task.reviewScore === 2)) questionComplete++;
      }
    }
    isValid = questionComplete >= reviewData.contentInfo.questions.length;
    if (!isValid) {
      return notification.open({
        message: 'Error',
        description: "You need to review all questions before finishing!"
      })
    }
    this.updateTaskStatus(reviewData, "done", function(err, res) {
      if (!err && res) {
        notification.open({
          message: 'Success',
          description: "Your review has been submitted successfully"
        })
        browserHistory.push('/review-tasks');
      }
    })
  },

  updateTaskStatus: function(task, status, callback){
    callback = callback || function(){};
    task = task || this.state.reviewTaskData;
    var options = {
      taskId: task._id,
      body: {
        status: status
      }
    }
    ReviewTaskRes.updateReviewTask(options, function(err, res) {
      return callback(err, res);
    })
  },

  updateOtherReviewTasks: function() {
    this.setState({
      updateOtherReviewTasksCount: this.state.updateOtherReviewTasksCount + 1
    }, () => {
      if (this.state.updateOtherReviewTasksCount < this.state.reviewTaskData.contentInfo.questions.length) return;
      var taskData = this.state.reviewTaskData,
          currentRound = taskData.reviewRound,
          currentRoundIndex = currentRound - 1;
      taskData.currentRoundStat = {a: 0, n: 0};
      var currentUser = Auth.getCurrentUser();
      for (var i = 0; i < taskData.contentInfo.questions.length; i++) {
        var kquestion = taskData.contentInfo.questions[i].kquestion;
        for (var j = 0; j < kquestion.reviewTasks.length; j++) {
          var task = kquestion.reviewTasks[j];
          if (task.reviewRound !==  taskData.contentInfo.current_review_round) continue;
          if (currentUser.role === 'admin') {
            if (task.type === 'COLLECTION_KQUESTIONS_ADMIN_REVIEW') {
              if (task.reviewScore === 1) taskData.currentRoundStat.a += 1;
              else if (task.reviewScore === 2) taskData.currentRoundStat.n += 1;
            }
          } else if (task.reviewer === currentUser._id) {
            if (task.type === "COLLECTION_KQUESTIONS_REVIEW") {
              if (task.reviewScore === 1) taskData.currentRoundStat.a += 1;
              else if (task.reviewScore === 2) taskData.currentRoundStat.n += 1;
            }
          }
        }
      }
      this.setState({
        reviewTaskData: taskData
      })
    });
  },

  getInitialState: function() {
    return {
      reviewTaskData: {
        contentInfo: {
          questions: []
        },
        collectionMessages: []
      },
      conceptsMap: null,
      isLoading: false,
      updateOtherReviewTasksCount: 0
    };
  },

  render: function() {
    var _this = this,
        currentUser = Auth.getCurrentUser(),
        taskData = this.state.reviewTaskData,
        conceptsMap = this.state.conceptsMap;

    var collectionData = taskData.contentInfo;
    for (var i in collectionData.questions) {
      var question = collectionData.questions[i];
      var isNeedRevision = false;
      for (var k in question.kquestion.reviewTasks) {
        var reviewTask = question.kquestion.reviewTasks[k];
        if (collectionData.current_review_round === reviewTask.reviewRound && currentUser._id === reviewTask.reviewer && reviewTask.type === 'COLLECTION_KQUESTIONS_REVIEW' && reviewTask.reviewScore === 2) isNeedRevision = true;
      }
      question.isNeedRevision = isNeedRevision;
    }

    return (
      <div className="review-collection-container">
        <div className="content-toolbar">
          <h3>Review Collection</h3>
          <div className="btn-holder">
            <RaisedButton
              secondary={true}
              label="Finish"
              icon={
                <i
                  className="fa fa-check"
                  style={{color: "#e47923", background: "white", borderRadius: "50%", width: "18px", lineHeight: "18px"}}>
                </i>
              }
              onClick={_this.submitFinishReview}/>
          </div>
        </div>
        <hr className="margin-bottom-10"/>
        <h3
          className="margin-top-10"
          style={{fontSize: "20px", color: "#555"}}>
          {taskData && taskData.contentInfo && taskData.contentInfo.title}
        </h3>
        <div className="row margin-bottom-10">
          <div className="col-md-8">
            <CollectionInfoRow
              data={taskData.contentInfo}
              conceptsMap={conceptsMap}/>
            <div className="text-center">
              <div className="review-info dp-inline-block">
                <span className="txt-primary padding-right-15">
                  {'Approve: ' + (taskData.currentRoundStat ? taskData.currentRoundStat.a : '-')}
                </span>
                <span className="txt-danger">
                  {'Need Review: ' + (taskData.currentRoundStat ? taskData.currentRoundStat.n : '-')}
                </span>
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="collection-info text-center">
              <span className="txt-secondary"><b>Reviews</b></span>
            </div>
          </div>
        </div>
        {
          conceptsMap && taskData.contentInfo.questions.length > 0 && (
            taskData.contentInfo.questions.map(function(question, index) {
              return (
                <div key={index} className="review-collection row" style={{
                  display: 'flex',
                  backgroundColor: question.isNeedRevision ? 'bisque' : null
                }}>
                  <div className="content-play col-md-8">
                    <QuestionContent
                      questions={[question]}
                      questionIndex={index}
                      conceptLeafMapping={_this.state.conceptsMap}/>
                  </div>
                  <div className="review-content col-md-4">
                    <ReviewQuestion
                      question={question}
                      reviewTaskData={taskData}
                      taskMode='review'
                      updateOtherReviewTasks={_this.updateOtherReviewTasks}/>
                  </div>
                </div>
              )
            })
          )
        }
        {
          taskData.contentInfo._id &&
          <CollectionCommentList
            reviewTaskData={taskData}
            taskMode='review'
          />
        }
      </div>
    );
  },

  componentDidMount: function() {
    // var reviewTaskId = this.props.params.id;
    var _this = this;
    _this.setState({
      isLoading: true
    }, function() {
      // _this.retrieveAllNecessaryData();
      _this.retrieveMainReviewTaskData(function() {
        _this.retrieveConceptsMap();
      });
    })
  },

  retrieveConceptsMap: function(mainReviewData, callback) {
    callback = callback || function(){};
    mainReviewData = mainReviewData || this.state.reviewTaskData;
    var _this = this;
    ConceptRes.retrieveAllConceptsMap(function(err, conceptsMap) {
      if (err) return;
      mainReviewData.contentInfo = ConceptRes.buildConceptToCollectionData(mainReviewData.contentInfo, conceptsMap);
      _this.setState({
        reviewTaskData: mainReviewData,
        isLoading: false,
        conceptsMap: conceptsMap
      }, function() {
        return callback();
      })
    })
  },

  retrieveMainReviewTaskData: function(callback) {
    callback = callback || function(){};
    var reviewTaskId = this.props.params.id;
    var _this = this;
    ReviewTaskRes.retrieveSingleReviewTask({taskId: reviewTaskId}, function(err, res) {
      if (err) {
        const btn = (
          <button
            className="btn"
            onClick={Helpers.windowReload}>
            Try again
          </button>
        );
        notification.open({
          message: 'Error',
          description: 'Cannot load this task',
          btn,
          duration: 0
        });
        return;
      }
      if (res.status === 'new') {
        _this.updateTaskStatus(res, 'reviewing', function(err2, res2) {
          // If cannot update status by any errors, use old data, DO NOT throw error here - not necessary
          if (res2) res.status = res2.status;
          _this.setState({
            reviewTaskData: res
          }, function() {
            return callback();
          })
        })
      } else {
        _this.setState({
          reviewTaskData: res
        }, function() {
          return callback();
        })
      }
    })
  }

});

module.exports = ReviewCollection;



/** WEBPACK FOOTER **
 ** ./src/components/Tasks/Review/ReviewCollection.js
 **/